export default __webpack_public_path__ + "static/media/closeIcon.f498442c.svg";